import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
// import { authClient } from '../../../redux/api/Client';
import styles from './download-container.module.sass';
import { Spin } from 'antd';
import { STATUS } from '../../../../redux/constants';
import Icon from '@ant-design/icons';
import { ReactComponent as download_icon } from '../../../../assets/icons/Download.svg';

const DownloadIcon = (props) => <Icon component={download_icon} {...props} />;

const fileTypeMapping = {
  csv: 'csv',
  json: 'json',
  stix: 'stix.json',
};

export default function Download(props) {
  const params = useParams();
  const queryParams = new URLSearchParams(props.location.search);
  const [message, setMessage] = useState('');

  useEffect(() => {
    document.title = 'Download - Silent Push';
  }, []);

  useEffect(() => {
    let cancelRequest = false;

    // const downloadFile = async (fileUUID, fileType) => {
    //   return authClient.Download.fileDownload({ fileUUID, file_type: fileType })
    //     .then((res) => {
    //       if (!cancelRequest) {
    //         setMessage('Wait for download to complete');
    //         const link = document.getElementById('download_file');
    //         console.log(res.headers());
    //         const url = window.URL.createObjectURL(new Blob([res.data()]));
    //         link.href = url;
    //         const fileName = `${fileUUID}.${
    //           fileTypeMapping[fileType.toLowerCase()]
    //         }`;
    //         link.setAttribute('download', fileName); //or any other extension
    //         link.click();
    //       }
    //     })
    //     .catch((err) => {
    //       setMessage('Link expired!');
    //     });
    // };

    if (params['fileUUID']) {
      // const queryParams = new URLSearchParams(props.location.search);
      props.fileDownload(params['fileUUID'], queryParams?.get('file_type'));
      //downloadFile(params['fileUUID'], queryParams.get('file_type'));
    }
    return () => {
      cancelRequest = true;
    };
  }, [params['fileUUID']]);

  useEffect(() => {
    if (props.downloadStatus === STATUS.LOADED) {
      setMessage('Download finished');
    } else if (props.downloadStatus === STATUS.ERROR) {
      setMessage('Link expired');
    }
  }, [props.downloadStatus]);

  return (
    <div className={styles['download-container']}>
      {props.downloadStatus !== STATUS.LOADING ? (
        <div>
          <DownloadIcon style={{ fontSize: '32px', color: 'white' }} />
        </div>
      ) : (
        ''
      )}
      <Spin spinning={!!!message} />
      <a style={{ display: 'none' }} id="download_file" />
      <h1 className={styles['download-message']}>{message}</h1>

      <div style={{ display: 'inline-block', color: 'white' }}>
        {props.downloadStatus === STATUS.LOADED ||
        props.downloadStatus === STATUS.ERROR ? (
          <p>
            To {props.downloadStatus === STATUS.ERROR ? 'try to' : ''} download
            again, click{' '}
            <p
              style={{
                color: '#3C9AE8',
                display: 'inline',
                cursor: 'pointer',
              }}
              onClick={() =>
                props.fileDownload(
                  params['fileUUID'],
                  queryParams?.get('file_type'),
                )
              }
            >
              here
            </p>
            , or to return to Threat ranking, click{' '}
            <p
              style={{
                color: '#3C9AE8',
                display: 'inline',
                cursor: 'pointer',
              }}
              onClick={() => props.history.push('/')}
              // const queryParams = new URLSearchParams(props.location.search);
              //props.fileDownload(params['fileUUID'], queryParams?.get('file_type'))
            >
              here
            </p>
            .
          </p>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}
